export default __webpack_public_path__ + "static/media/Compressor.2467ca05.svg";